export default __webpack_public_path__ + "b0a87f51e833d8f326d01fbe3af8facd.svg";